// Module
var code = " <img ng-src=\"{{$ctrl.getAuctionImage().image}}\"/> ";
// Exports
export default code;